// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.css-1qprcsu-option{
  text-align: left;
  min-width: 95% !important; /* code added for width of dropdown */
}
.css-1vr111p-option{
  text-align: left;
  min-width: 95% !important; /* code added for width of dropdown */
}
.css-1r4vtzz{
  width: 100% !important;
}
.css-48ayfv{
  width: 100% !important;
}

/* code added for width of dropdown */
.css-48ayfv+div {
  width: 100%;
}
.css-1jllj6i-control{
  min-width: 95% !important;
}
.css-19t9a5b-control{
  min-width: 95% !important;
}
.css-vb64bg-control:hover{
  min-width: 95% !important;
}
.css-vb64bg-control {
  min-width: 95% !important;
}
.css-6y1x9t-control:hover {
  min-width: 95% !important;
}
.css-6y1x9t-control {
  min-width: 95% !important;
}
/* code added for width of dropdown */

input{
  height: inherit
}

.react-select__option{
  font-size: 80% !important;
}

.react-select__option1{
  font-size: 100% !important;
}

.react-select__menu-list{
  max-height: 150px !important;
  -webkit-overflow-scrolling:auto !important;
}

.kratos_filtr_btn{
  position: relative;
  top: 10px;
}
.font-kratos-head {
  font-size: 16px !important;
  font-weight: bolder;
  color: #000;
}
.font-kratos-head_a {
  font-size: 16px !important;
  font-weight: bolder;
  color: #000;
  text-align: left;
}
.font-kratos-head_pg{
  font-size: 1.25rem !important;
  color: #000;
  font-weight: 600;
}
.filter_kratos_icon {
  background: #fff !important;
  color: #83A4CF !important;
  padding: 0px 9px;
  font-size: 22px;
}
/* .filter_bus_icon:hover{
  background: #83A4CF !important;
  color: #fff !important;
} */
/* added code filter */
.filter_kratos_icon_f .btn:focus, .btn:focus-visible, .btn:focus-within, .btn:visited, .btn:active, .btn:target{
  background-color: #83A4CF;
  border-color: #83A4CF;
}

/*.btn:hover */`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Kratos/Driveanalysis_Kratos/CustomSelect_Kratos.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,yBAAyB,EAAE,qCAAqC;AAClE;AACA;EACE,gBAAgB;EAChB,yBAAyB,EAAE,qCAAqC;AAClE;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA,qCAAqC;;AAErC;EACE;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;AACA;;;GAGG;AACH,sBAAsB;AACtB;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,cAAc","sourcesContent":[".css-1qprcsu-option{\n  text-align: left;\n  min-width: 95% !important; /* code added for width of dropdown */\n}\n.css-1vr111p-option{\n  text-align: left;\n  min-width: 95% !important; /* code added for width of dropdown */\n}\n.css-1r4vtzz{\n  width: 100% !important;\n}\n.css-48ayfv{\n  width: 100% !important;\n}\n\n/* code added for width of dropdown */\n.css-48ayfv+div {\n  width: 100%;\n}\n.css-1jllj6i-control{\n  min-width: 95% !important;\n}\n.css-19t9a5b-control{\n  min-width: 95% !important;\n}\n.css-vb64bg-control:hover{\n  min-width: 95% !important;\n}\n.css-vb64bg-control {\n  min-width: 95% !important;\n}\n.css-6y1x9t-control:hover {\n  min-width: 95% !important;\n}\n.css-6y1x9t-control {\n  min-width: 95% !important;\n}\n/* code added for width of dropdown */\n\ninput{\n  height: inherit\n}\n\n.react-select__option{\n  font-size: 80% !important;\n}\n\n.react-select__option1{\n  font-size: 100% !important;\n}\n\n.react-select__menu-list{\n  max-height: 150px !important;\n  -webkit-overflow-scrolling:auto !important;\n}\n\n.kratos_filtr_btn{\n  position: relative;\n  top: 10px;\n}\n.font-kratos-head {\n  font-size: 16px !important;\n  font-weight: bolder;\n  color: #000;\n}\n.font-kratos-head_a {\n  font-size: 16px !important;\n  font-weight: bolder;\n  color: #000;\n  text-align: left;\n}\n.font-kratos-head_pg{\n  font-size: 1.25rem !important;\n  color: #000;\n  font-weight: 600;\n}\n.filter_kratos_icon {\n  background: #fff !important;\n  color: #83A4CF !important;\n  padding: 0px 9px;\n  font-size: 22px;\n}\n/* .filter_bus_icon:hover{\n  background: #83A4CF !important;\n  color: #fff !important;\n} */\n/* added code filter */\n.filter_kratos_icon_f .btn:focus, .btn:focus-visible, .btn:focus-within, .btn:visited, .btn:active, .btn:target{\n  background-color: #83A4CF;\n  border-color: #83A4CF;\n}\n\n/*.btn:hover */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
